/**
 * Utility functions for proposal form logic
 */

/**
 * Determines the correct insertType (Fact Sheet or Snapshot) based on program name
 * @param {string} programName - The name of the proposal program
 * @returns {string} "Fact Sheet", "Snapshot", or "" if no program provided
 */
export const getInsertTypeForProgram = (programName) => {
  if (!programName) return "";
  const lowerProgram = programName.toLowerCase();

  // Elements always uses Snapshot
  if (lowerProgram.includes("elements")) {
    return "Snapshot";
  }

  // CoreOps (non-Focused) and Global alphaTrend always use Fact Sheet
  if (
    (lowerProgram.includes("coreops") && !lowerProgram.includes("focused")) ||
    lowerProgram.includes("global alphatrend")
  ) {
    return "Fact Sheet";
  }

  // Default to Fact Sheet for all other programs
  return "Fact Sheet";
};

/**
 * Checks if a program should have its insertType radio buttons disabled
 * Programs with only one valid insertType option should have radio buttons disabled
 * @param {string} programName - The name of the proposal program
 * @returns {boolean} true if radio buttons should be disabled
 */
export const shouldDisableInsertTypeRadios = (programName) => {
  if (!programName) return true;
  const lowerProgram = programName.toLowerCase();

  // These programs have only one valid option and should have radios disabled
  return (
    lowerProgram.includes("elements") ||
    (lowerProgram.includes("coreops") && !lowerProgram.includes("focused")) ||
    lowerProgram.includes("global alphatrend")
  );
};

/**
 * Checks if a program is a Fusion program
 * @param {string} programName - The name of the proposal program
 * @returns {boolean} true if program is a fusion program
 */
export const isFusionProgram = (programName) => {
  if (!programName) return false;
  return programName.toLowerCase().includes("fusion");
};
